import Html from 'components/html';
import { SegmentationData } from 'modules/product-details/types';
import { forwardRef } from 'react';
import renderDocument from './utils/renderDocuments';

interface ViewPropTypes {
  classNames: string;
  content: SegmentationData['usps'];
  dataTest: string;
  /** Usp title to override title */
  uspTitle?: React.ReactNode;
}

const UspsView = forwardRef<HTMLDivElement, ViewPropTypes>(
  ({ classNames, content, dataTest, uspTitle }, ref) => {
    if (typeof content === 'string') {
      // Sometimes the content  contains empty list items and p tag, which renders a empty bullet point,
      // this regex removes the empty list items
      let cleanedContent = content.replace(/<li>\s*<\/li>|<p>\s*<\/p>/g, '');
      if (uspTitle) {
        cleanedContent = cleanedContent.replace(/<\/?h[34]>.*?<\/h[34]>/g, '');
      }

      if (uspTitle) {
        return (
          <div className={classNames} ref={ref}>
            {uspTitle && (
              <h3>
                <strong>{uspTitle}</strong>
              </h3>
            )}
            <Html data-test={dataTest}>{cleanedContent}</Html>
          </div>
        );
      }

      return (
        <>
          <Html data-test={dataTest} className={classNames} ref={ref}>
            {cleanedContent}
          </Html>
        </>
      );
    }

    return (
      <div data-test={dataTest} className={classNames} ref={ref}>
        {renderDocument({ richTextDocument: content, uspTitle })}
      </div>
    );
  }
);

UspsView.displayName = 'UspsView';

export default UspsView;
